/**
 * @documental
 * @export Spacer
 * @name
 * Stack.Spacer
 */

import { FC } from "react";

/**
 * Creates a space between two entries in the `Stack` which spans the remaining height.
 */
export const Spacer: FC = () => {
  return null;
};
